import { HttpBadStatusCodeError } from '@cian/peperrors/shared';

import { TThunkAction } from '../../../types/redux';
import { getDiscussionsLoading } from './getDiscussionsLoading';
import { getDiscussionsSucceed } from './getDiscussionsSucceed';
import { getDiscussionsFailed } from './getDiscussionsFailed';
import { mkDiscussions } from '../../../__stubs__/mocks/discussions';

export const getDiscussions = (): TThunkAction<Promise<void>> => {
  return async (dispatch, getState, context) => {
    const { logger } = context;

    dispatch(getDiscussionsLoading());

    try {
      const { response, statusCode } = { response: { data: mkDiscussions() }, statusCode: 200 };

      if (statusCode !== 200 || !response?.data) {
        await Promise.reject(
          new HttpBadStatusCodeError('Не удалось загрузить обсуждения', statusCode, 'actions.getDiscussions'),
        );

        return;
      }

      dispatch(getDiscussionsSucceed(response.data));
    } catch (e) {
      logger.error(e, {
        domain: 'actions.getDiscussions',
      });

      dispatch(getDiscussionsFailed());
    }
  };
};
